import type { TimeDuration } from "Infrastructure/ApiZfp/Schema";
import type { ResourcePathType } from "Infrastructure/Translations/Resources";
import { inflectMonths, inflectYears } from "Infrastructure/Utils/LanguageUtils";

export const getTimeDurationFormatted = (
  timeDuration: TimeDuration,
  t: (resourcePath: ResourcePathType, options?: any) => string,
): string => {
  const { years, months } = timeDuration;

  let timeDurationFormatted = "";

  if (years > 0) {
    timeDurationFormatted += inflectYears(years, t);
    timeDurationFormatted += " ";
  }

  timeDurationFormatted += inflectMonths(months, t);

  return timeDurationFormatted;
};
